import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../stores/auth.store';
import './SignInForm.scss';
import { dashboardPath, devicesPath } from '../../routes';

interface FormValues {
  username: string;
  password: string;
}

const SignInForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm<FormValues>();
  const login = useAuthStore((state) => state.login);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values: FormValues) => {
    try {
      await login(values.username, values.password);
      navigate(dashboardPath + '/' + devicesPath);
    } catch (error) {
      messageApi.error('No se pudo iniciar sesión. Por favor, inténtelo de nuevo.');
    }
  };

  return (
    <div>
      {contextHolder}
      <Form<FormValues> form={form} name="login" onFinish={onFinish} className={'SignInForm'}>
        {/* Username */}
        <Form.Item
          name="username"
          rules={[
            { required: true, message: '¡Por favor introduzca su email!' },
            { type: 'email', message: 'El email no es válido' },
          ]}
        >
          <Input type="email" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Usuario" />
        </Form.Item>

        {/* Password */}
        <Form.Item name="password" rules={[{ required: true, message: '¡Porfavor introduzca su contraseña!' }]}>
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Contraseña"
          />
        </Form.Item>

        {/* Submit */}
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" block>
            Log in
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SignInForm;
